import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetSeoDataService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.mapperFactory
   * */
  constructor({config, mapperFactory: seoMetaInformationMapper}) {
    super()
    this._config = config
    this._seoMetaInformationMapper = seoMetaInformationMapper
  }

  @inlineError
  async execute({seoDataRequestVO}) {
    const seoDataRequest = seoDataRequestVO.toCleanJSON()
    return this._seoMetaInformationMapper.map(seoDataRequest)
  }
}
